import React, { useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Box, CardMedia, Grid } from "@material-ui/core";

import { useSpring, useChain, animated, useTransition } from "react-spring";

import EmojiPeopleTwoToneIcon from "@material-ui/icons/EmojiPeopleTwoTone";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) =>
  createStyles({
    aspectRatioBox: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      borderRadius: 12,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      textAlign: "center",
      fontSize: 20,
      color: "white",
      background: "no-repeat center center",
      backgroundImage: "url(/images/company/company.png)",
      backgroundSize: "100%",
    },
  })
);

function AboutCompany({}) {
  const classes = useStyles();
  const [on, toggle] = useState(false);

  const props = useSpring({
    from: {
      transform: on ? "translate(0px)" : "translate(8px)",
      color: on ? "black" : "rgb(188, 36, 60)",
    },
    to: {
      transform: on ? "translate(8px)" : "translate(0px)",
      color: on ? "rgb(188, 36, 60)" : "black",
    },
    // transform: translate(0px)
    // config: { duration: 400 },
  });

  return (
    <Grid
      xs={3}
      item
      container
      style={{ padding: 32 }}
      onMouseEnter={() => {
        toggle(true);
      }}
      onMouseLeave={() => {
        toggle(false);
      }}
    >
      {/* <Box component={"div"} className={classes.aspectRatioBox}>
        <Box
          component={"div"}
          className={classes.aspectRatioBoxInside}
          style={{ backgroundImage: `url(/images/main/about/1.jpg)` }}
        ></Box>
      </Box> */}
      <Grid
        item
        container
        justify={"center"}
        style={{
          fontSize: 16,
          fontWeight: 700,
          paddingBottom: 24,
          paddingTop: 24,
        }}
        xs={12}
      >
        <Grid style={{ ...props }} item xs={2} component={animated.div}>
          {/* <ArrowForwardIcon style={{}} /> */}
          {/* <FontAwesomeIcon icon={faMap} /> */}
          <EmojiPeopleTwoToneIcon style={{}} />
        </Grid>
        <Grid item style={{ paddingRight: 8, paddingTop: 2 }} xs={10}>
          <Link to={"/about"}>문화재 소개</Link>
        </Grid>
      </Grid>
      {/* </Box> */}
    </Grid>
  );
}

export default AboutCompany;
